import axios from "axios";
import { IOperatorPerformanceDetails } from "../models/OperatorPerformanceDetails";

const OperatorPerformanceDetailsService = {
  getOperatorPerformanceDetails: async (
    operatorId: number | string,
    pageNumber: number = 1,
    pageSize: number = 5
  ): Promise<IOperatorPerformanceDetails> => {
    const accessToken = localStorage.getItem("AccessToken");

    const response = await fetch(
      `${process.env.REACT_APP_API_TODO_LIST_ENDPOINT}/leads/operatorPerformance/${operatorId}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(accessToken
            ? { Authorization: `Bearer ${accessToken}` }
            : {}),
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch operator performance details");
    }

    const data = await response.json();

    return {
      operatorId: operatorId.toString(),
      operatorName: `${data.firstName ?? ""} ${data.lastName ?? ""}`.trim(),
      operatorEmail: data.email ?? "",
      operatorPhone: data.phone ?? "",
      operatorCompany: data.company ?? "",
      operatorJobTitle: data.jobTitle ?? "",
      operatorType: data.type ?? "",
      totalLeads: data.totalLeads ?? 0,
      PageNumber: data.pageNumber ?? 1,
      PageSize: data.pageSize ?? 5,
      TotalPages: data.totalPages ?? 1,
      leads: data.leadDtos ?? [],
    };
  },

  downloadOperatorPerformanceCsv: async (operatorId: number | string): Promise<void> => {
    const accessToken = localStorage.getItem("AccessToken");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_TODO_LIST_ENDPOINT}/leads/downloadOperatorPorfomance/${operatorId}`,
        {
          method: "GET",
          headers: {
            ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed with status ${response.status}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `operator-performance-${operatorId}.csv`);

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading operator performance CSV:", error);
      throw error;
    }
  },

};

export default OperatorPerformanceDetailsService;